import React from 'react';
import {withSystem, Plugins, Expressions, Atom} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  TListOfElement,
  TTypeConstructor,
  TRecord,
  TText,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {List} from 'immutable';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
} from '@packages/utilities/data-utils';

const maybeAddCurrent =
  (current: unknown, dataTab: unknown) => (classes: List<string>) => {
    return current === dataTab ? classes.push('w--tab-active') : classes;
  };

const TabsPane = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const Tag = getInPojo(data, ['tag']) as React.ElementType;
    const dataTab = getInPojo(data, ['attr', 'data-w-tab']);

    const tabsPaneClasses = classes
      .push('w-tab-pane')
      .update(maybeAddCurrent(context.get('current'), dataTab));

    return (
      <Tag {...generateAttributes(attributes, tabsPaneClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: {
    type: 'Derived',
    defaultValue: 'Tab Pane',
    getFromElement: (element) => {
      const tabName = Expressions.getElementDataAt(
        element,
        [
          {in: 'Record', at: 'attr'},
          {in: 'Record', at: 'data-w-tab'},
        ],
        'Text',
        ''
      );
      return `Tab Pane [${tabName}]`;
    },
  },
  constraints: {
    parent: [
      {
        is: 'TabsContent',
        name: 'Non-Tabs-Content Item',
        rule: 'RequireOnly',
      },
    ],
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'The tab element’s display property can’t be changed, as doing so would break its functionality.',
    },
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Tabs'), iconName('TabsPane')),
  },
  showEmpty: true,
  render: TabsPane,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    attr: TRecord({
      'data-w-tab': TText,
    }),
    children: TListOfElement,
  },
});

export default config;
